// --- Receipt Queries ---
// Note: Receipts are read-only — generated automatically on recordPayment.
// All receipt operations are queries (no standalone mutations).

export const getReceiptByIdQuery = `
  query GetReceiptById($input: GetReceiptByIdInput!) {
    getReceiptById(input: $input) {
      code
      receipt {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

export const getReceiptByPaymentQuery = `
  query GetReceiptByPayment($input: GetReceiptByPaymentInput!) {
    getReceiptByPayment(input: $input) {
      code
      receipt {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

export const listReceiptsByInvoiceQuery = `
  query ListReceiptsByInvoice($input: ListReceiptsByInvoiceInput!) {
    listReceiptsByInvoice(input: $input) {
      code
      receipts {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

export const listReceiptsByOrderQuery = `
  query ListReceiptsByOrder($input: ListReceiptsByOrderInput!) {
    listReceiptsByOrder(input: $input) {
      code
      receipts {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

export const listReceiptsByStoreQuery = `
  query ListReceiptsByStore {
    listReceiptsByStore {
      code
      receipts {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;

export const listReceiptsByCompanyQuery = `
  query ListReceiptsByCompany {
    listReceiptsByCompany {
      code
      receipts {
        receiptId
        paymentId
        invoiceId
        invoiceNumber
        orderId
        orderNumber
        amount
        paymentDate
        reference
        paymentMethod
        createdAt
        status
      }
    }
  }
`;
